var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlanFill = function SvgPlanFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10Zm.6-8.163c1.019.227 1.506 1.068 1.537 1.12l.051.09-.874.484-.05-.084c-.015-.027-.39-.665-1.163-.67-.382.022-.728.127-.915.337a.709.709 0 0 0-.181.561.551.551 0 0 0 .083.248.71.71 0 0 0 .218.203c.21.136.548.265 1.08.441h.002c.444.154.865.317 1.189.564.329.25.556.588.611 1.08.057.493-.095.971-.429 1.342-.291.325-.696.533-1.159.619V12h-1v-.838c-1.026-.228-1.512-1.077-1.537-1.123l-.048-.087.872-.486.049.086c.014.026.39.666 1.165.67.428-.004.723-.123.913-.337a.709.709 0 0 0 .114-.785.608.608 0 0 0-.173-.185c-.167-.125-.441-.246-.888-.4l-.007-.002c-.474-.157-.953-.316-1.327-.567-.383-.256-.66-.612-.721-1.158-.057-.493.096-.97.429-1.342.291-.325.696-.533 1.159-.619V4h1v.837Z",
    fill: "#000"
  })));
};
export default SvgPlanFill;